import { Icon, IconButton } from "@chakra-ui/react"
import { CarouselButtonProps } from "@definitions/types"
import { LuChevronLeft, LuChevronRight } from "react-icons/lu"

export default function CarouselButton(
  props: CarouselButtonProps
): JSX.Element {
  const { direction, ...rest } = props

  const nextIcon = () => (
    <Icon
      as={LuChevronRight}
      color={"white"}
      w={8}
      h={8}
      me={{ base: -2, sm: -4 }}
      _groupHover={{ me: 0 }}
      transition={"all 0.2s ease-in-out"}
    />
  )

  const prevIcon = () => (
    <Icon
      as={LuChevronLeft}
      color={"white"}
      w={8}
      h={8}
      ms={{ base: -2, sm: -4 }}
      _groupHover={{ ms: 0 }}
      transition={"all 0.2s ease-in-out"}
    />
  )

  return (
    <IconButton
      icon={direction === "next" ? nextIcon() : prevIcon()}
      role={"group"}
      bg={"brand.secondary"}
      borderRadius={"full"}
      size={"lg"}
      position={"absolute"}
      top={{ base: "auto", sm: "50%" }}
      bottom={{ base: 0, sm: "auto" }}
      w={{ base: 8, sm: 12 }}
      h={{ base: 8, sm: 12 }}
      minWidth={{ base: 8, sm: 12 }}
      zIndex={1}
      left={{
        base: "auto",
        sm: direction === "prev" ? 2 : "auto",
      }}
      right={{
        base: direction === "prev" ? 12 : 0,
        sm: direction === "next" ? 2 : "auto",
      }}
      transition={"all 0.2s ease-in-out"}
      {...rest}
      _hover={{
        width: { base: 8, sm: 14 },
        height: { base: 8, sm: 14 },
      }}
    />
  )
}
